import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/CreateTalentInfluencer.graphql';
import { Mutation, MutationcreateTalentInfluencerArgs } from '../../__generated__/globalTypes';

export const useCreateTalentInfluencerMutation = (
  options?: MutationHookOptions<Mutation, MutationcreateTalentInfluencerArgs>
) => {
  const [callCreateTalentInfluencer, result] = useMutation<Mutation, MutationcreateTalentInfluencerArgs>(
    MUTATION,
    options
  );

  return { callCreateTalentInfluencer, ...result };
};

export type CreateTalentInfluencerMutationFunction = Mutation['createTalentInfluencer'];
